import React from 'react';
import { Modal, Text } from '@fragments';
import { QRCodeSVG } from 'qrcode.react';
import useHandoff from './hooks/useHandoff';
import './styles.scss';

export default function MobileDialog({ studio: s, onClose }) {
  const { t } = s;
  const { url } = useHandoff(s);
  return <Modal open closeLabel={t('close')} onClose={onClose} title={t('mobile')} className="studio-dialog" size="sm">
    <div className="studio-fields studio-qr"><Text.p contrast={7}>{t('mobileHint')}</Text.p>
      <div className="studio-qr__code"><QRCodeSVG value={url} size={180} level="M" includeMargin /></div>
      <Text.caption contrast={6}>{t('persistentLink')}</Text.caption>
      <a href={url} target="_blank" rel="noreferrer"><Text.span contrast={8}>{t('openScript')}</Text.span></a>
      {['localhost','127.0.0.1'].includes(window.location.hostname) && <Text.caption contrast={6}>{t('qrLocalhost')}</Text.caption>}
    </div>
  </Modal>;
}
